<template>
	<div>
		<div class="d-flex justify-space-between">
			<h2 class="mb-4">Ticket</h2>
			<v-btn color="primary" @click="entity = {};dialogAdd = true;">Add Ticket</v-btn>
		</div>

		<v-card flat>
			<v-simple-table>
				<template v-slot:default>
					<thead>
						<tr>
							<th class="text-left">Id</th>
							<th class="text-left">Name</th>
							<th class="text-left">Exhibitor Type</th>
							<th class="text-left">Booth Id</th>
							<th class="text-left">Booth Name</th>
							<th class="text-center"></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, idxItem) in entityList" :key="idxItem">
							<td>{{ item.id }}</td>
							<td>{{ item.name }}</td>
							<td>
								<v-icon v-if="item.exhibitor">mdi-check</v-icon>
							</td>
							<td>{{ item.boothId }}</td>
							<td>{{ item.boothName }}</td>
							<td class="text-center">
								<v-btn color="primary" class="ma-2" @click="entity = Object.assign({}, item);dialogEdit = true;">
									Edit
									<v-icon dark>mdi-pencil</v-icon>
								</v-btn>
								<v-btn class="ma-2" @click="selectedId = item.id;dialogDelete = true;">
									Delete
									<v-icon dark>mdi-delete</v-icon>
								</v-btn>
							</td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
		</v-card>

		<v-dialog v-model="dialogAdd" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Add</span>
				</v-card-title>
				<v-card-text>
					<v-text-field v-model="entity.name" label="Name"></v-text-field>
					<v-switch v-model="entity.exhibitor" label="Exhibitor Type"></v-switch>
					<v-select
						v-if="entity.exhibitor"
						v-model="entity.boothId"
						:items="boothList"
						item-text="name"
						item-value="id"
						label="Booth"
					></v-select>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogAdd = false">Cancel</v-btn>
					<v-btn @click="add" color="primary darken-1">Add</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogEdit" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Edit</span>
				</v-card-title>
				<v-card-text>
					<v-text-field v-model="entity.name" label="Name"></v-text-field>
					<v-switch v-model="entity.exhibitor" label="Exhibitor Type"></v-switch>
					<v-select
						v-if="entity.exhibitor"
						v-model="entity.boothId"
						:items="boothList"
						item-text="name"
						item-value="id"
						label="Booth"
					></v-select>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogEdit = false">Cancel</v-btn>
					<v-btn @click="edit" color="primary darken-1">Edit</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogDelete" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Delete</span>
				</v-card-title>
				<v-card-text>Are you sure you want delete this?</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogDelete = false">Cancel</v-btn>
					<v-btn @click="remove" color="primary darken-1">Delete</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios";

export default {
	props: ["experienceId"],
	data() {
		return {
			boothList: [],
			entityList: null,
			entity: {},
			dialogAdd: false,
			dialogEdit: false,
			dialogDelete: false
		};
	},
	mounted() {
		this.listBooth();
		this.list();
	},
	methods: {
		listBooth() {
			axios
				.get("/system/booth/list?experienceId=" + this.experienceId)
				.then(response => {
					this.boothList = response.data;
					this.boothList.splice(0, 0, { id: null, name: "" });
				})
				.catch(() => {});
		},
		list() {
			axios
				.get("/system/ticket/list?experienceId=" + this.experienceId)
				.then(response => {
					this.entityList = response.data;
				})
				.catch(() => {});
		},
		add() {
			this.entity.experienceId = this.experienceId;
			axios
				.post("/system/ticket/add", {
					entity: this.entity
				})
				.then(() => {
					this.dialogAdd = false;
					this.list();
				})
				.catch(() => {});
		},
		edit() {
			axios
				.post("/system/ticket/edit", {
					entity: this.entity
				})
				.then(() => {
					this.dialogEdit = false;
					this.list();
				})
				.catch(() => {});
		},
		remove() {
			axios
				.post("/system/ticket/delete", {
					id: this.selectedId
				})
				.then(() => {
					this.dialogDelete = false;
					this.list();
				})
				.catch(() => {});
		}
	}
};
</script>
